import React, { useState } from 'react';
import BuildIcon from '@mui/icons-material/Build';
import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';
import SnackBar from 'src/components/SnackBar/SnackBar';

const TabTwo = ({
  commonPermissions,
  setcommonPermissions,
  generalDetails,
  setgeneralDetails,
  employementDetails,
  setEmployementDetails,
  bankingDetails,
  setBankingDetails,
  contactDetails,
  setcontactDetails,
  onClickAll,
  isEdit
}) => {
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Common Permissions
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="employees-form-common-edit-all"
            control={
              <Checkbox
                id="employees-common-edit-all"
                checked={commonPermissions.every((dash) => dash.value)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(
                    commonPermissions,
                    'common',
                    setcommonPermissions,
                    e
                  )
                }
              />
            }
            label="All"
          />
        </Grid>
        {commonPermissions.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={commonPermissions[index]?.value}
                    onChange={(e) => {
                      let items = [...commonPermissions];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setcommonPermissions(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            General Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="employees-form-general-edit-all"
            control={
              <Checkbox
                id="employees-general-edit-all"
                checked={generalDetails.every((dash) => dash.view)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(generalDetails, 'status', setgeneralDetails, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            disabled={isEdit}
            checked={generalDetails.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissions?.filter((comm) => comm?.name === 'Edit')[0]
                  ?.value
              ) {
                onClickAll(generalDetails, 'edit', setgeneralDetails, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {generalDetails.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={
                      data.name === 'Name in Jira' ||
                      data.name === 'Name' ||
                      data.name === 'Gender' ||
                      isEdit
                    }
                    checked={generalDetails[index]?.view}
                    onChange={(e) => {
                      if (
                        data.name !== 'Name in Jira' &&
                        data.name !== 'Name'
                      ) {
                        let items = [...generalDetails];
                        let item = { ...items[index] };
                        item = {
                          category: data.category,
                          edit: data.edit,
                          name: data.name,
                          tab: data.tab,
                          view: !data.view
                        };
                        items[index] = item;
                        setgeneralDetails(items);
                      }
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissions?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...generalDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      if (!isEdit) setgeneralDetails(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Contact Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="employees-form-contact-edit-all"
            control={
              <Checkbox
                id="employees-contact-edit-all"
                checked={contactDetails.every((dash) => dash.view)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(contactDetails, 'status', setcontactDetails, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            disabled={isEdit}
            checked={contactDetails.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissions?.filter((comm) => comm?.name === 'Edit')[0]
                  ?.value
              ) {
                onClickAll(contactDetails, 'edit', setcontactDetails, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {contactDetails.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={contactDetails[index]?.view}
                    onChange={(e) => {
                      let items = [...contactDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setcontactDetails(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissions?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...contactDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      if (!isEdit) setcontactDetails(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>

      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Banking Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="employees-form-banking-edit-all"
            control={
              <Checkbox
                id="employees-banking-edit-all"
                checked={bankingDetails.every((dash) => dash.view)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(bankingDetails, 'status', setBankingDetails, e)
                }
              />
            }
            label="All"
          />
          <Checkbox
            disabled={isEdit}
            checked={bankingDetails.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissions?.filter((comm) => comm?.name === 'Edit')[0]
                  ?.value
              ) {
                onClickAll(bankingDetails, 'edit', setBankingDetails, e);
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {bankingDetails.map((data, index) => {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={bankingDetails[index]?.view}
                    onChange={(e) => {
                      let items = [...bankingDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setBankingDetails(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) && (
                <BuildIcon
                  onClick={() => {
                    if (
                      commonPermissions?.filter(
                        (comm) => comm?.name === 'Edit'
                      )[0]?.value
                    ) {
                      let items = [...bankingDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: !data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: data.view
                      };
                      items[index] = item;
                      if (!isEdit) setBankingDetails(items);
                    } else {
                      setSnackBarMessage(
                        'You cannot give edit permissions without checking the Edit checkbox'
                      );
                      setSnackbarSeverity('error');
                      setSnackBarOpen(true);
                    }
                  }}
                  sx={{
                    fontSize: '0.8rem',
                    color: `${data.edit === false ? 'gray' : 'blue'}`
                  }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>

      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Employment Details
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ mt: 1 }}>
          <FormControlLabel
            id="employees-form-employement-edit-all"
            control={
              <Checkbox
                id="employees-employement-edit-all"
                checked={employementDetails.every((dash) => dash.view)}
                disabled={isEdit}
                onClick={(e) =>
                  onClickAll(
                    employementDetails,
                    'status',
                    setEmployementDetails,
                    e
                  )
                }
              />
            }
            label="All"
          />
          <Checkbox
            disabled={isEdit}
            checked={employementDetails.every((dash) => dash.edit)}
            onClick={(e) => {
              if (
                commonPermissions?.filter((comm) => comm?.name === 'Edit')[0]
                  ?.value
              ) {
                onClickAll(
                  employementDetails,
                  'edit',
                  setEmployementDetails,
                  e
                );
              } else {
                setSnackBarMessage(
                  'You cannot give edit permissions without checking the Edit checkbox'
                );
                setSnackbarSeverity('error');
                setSnackBarOpen(true);
              }
            }}
            icon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `gray`
                }}
              />
            }
            checkedIcon={
              <BuildIcon
                sx={{
                  fontSize: '0.8rem',
                  color: `blue`
                }}
              />
            }
          />
        </Grid>
        {employementDetails.map((data, index) => {
          return data.name !== 'Employee ID' && (
            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={employementDetails[index]?.view}
                    onChange={(e) => {
                      let items = [...employementDetails];
                      let item = { ...items[index] };
                      item = {
                        category: data.category,
                        edit: data.edit,
                        name: data.name,
                        tab: data.tab,
                        view: !data.view
                      };
                      items[index] = item;
                      setEmployementDetails(items);
                    }}
                  />
                }
                label={data.name}
              />
              {(data.edit === false || data.edit === true) &&
                data.name !== 'Tier' &&
                data.name !== 'Feedback' &&
                data.name !== 'Tracking Status' &&
                data.name !== 'Joined Date' &&
                data.name !== 'Experience Hierachy' &&
                data.name !== 'Reporting Managers' && (
                  <BuildIcon
                    onClick={() => {
                      if (
                        commonPermissions?.filter(
                          (comm) => comm?.name === 'Edit'
                        )[0]?.value
                      ) {
                        let items = [...employementDetails];
                        let item = { ...items[index] };
                        item = {
                          category: data.category,
                          edit: !data.edit,
                          name: data.name,
                          tab: data.tab,
                          view: data.view
                        };
                        items[index] = item;
                        if (!isEdit) setEmployementDetails(items);
                      } else {
                        setSnackBarMessage(
                          'You cannot give edit permissions without checking the Edit checkbox'
                        );
                        setSnackbarSeverity('error');
                        setSnackBarOpen(true);
                      }
                    }}
                    sx={{
                      fontSize: '0.8rem',
                      color: `${data.edit === false ? 'gray' : 'blue'}`
                    }}
                  />
                )}
            </Grid>
          );
        })}
      </Grid>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
    </>
  );
};

export default TabTwo;
